<template>
  <div class="legal-page">
    <!-- Intro Section -->
    <PolicyIntroComp :content="introContent" />

    <!-- Terms Content Section -->
    <PolicyContentComp :content="contentData" />
  </div>
</template>

<script>
import { onMounted, ref } from 'vue'
import WOW from 'wowjs'
import PolicyIntroComp from '@/components/PolicyIntroComp.vue'
import PolicyContentComp from '@/components/PolicyContentComp.vue'

export default {
  name: 'TermsPage',
  components: {
    PolicyIntroComp,
    PolicyContentComp
  },
  setup() {
    onMounted(() => {
      // Initialize WOW.js
      new WOW.WOW({
        mobile: false
      }).init()
    })

    // Intro content object
    const introContent = ref({
      sectionLabel: "Legal Information",
      mainTitle: "Terms of Service",
      description: "Please read these terms of service carefully before using our services. By using our services, you agree to be bound by these terms."
    })

    // Terms content object
    const contentData = ref({
      sections: [
        {
          title: "1. Acceptance of Terms",
          paragraphs: [
            {
              type: "text",
              content: "By accessing and using our services, you accept and agree to be bound by the terms and provision of this agreement. If you do not agree to abide by the above, please do not use this service."
            }
          ]
        },
        {
          title: "2. Use License",
          paragraphs: [
            {
              type: "text",
              content: "Permission is granted to temporarily download one copy of the materials on our website for personal, non-commercial transitory viewing only. This is the grant of a license, not a transfer of title, and under this license you may not:"
            },
            {
              type: "unordered",
              items: [
                "Modify or copy the materials",
                "Use the materials for any commercial purpose or for any public display",
                "Attempt to reverse engineer any software contained on the website",
                "Remove any copyright or other proprietary notations from the materials"
              ]
            }
          ]
        },
        {
          title: "3. Service Availability",
          paragraphs: [
            {
              type: "text",
              content: "We strive to maintain high service availability, but we do not guarantee uninterrupted access to our services. We reserve the right to:"
            },
            {
              type: "unordered",
              items: [
                "Modify or discontinue services with reasonable notice",
                "Perform maintenance that may temporarily affect service availability",
                "Suspend services for security or legal reasons",
                "Update or change service features and functionality"
              ]
            }
          ]
        },
        {
          title: "4. User Responsibilities",
          paragraphs: [
            {
              type: "text",
              content: "As a user of our services, you agree to:"
            },
            {
              type: "unordered",
              items: [
                "Provide accurate and complete information",
                "Maintain the confidentiality of your account credentials",
                "Use services in compliance with applicable laws and regulations",
                "Not engage in any illegal or unauthorized activities",
                "Respect intellectual property rights of others"
              ]
            }
          ]
        },
        {
          title: "5. Intellectual Property",
          paragraphs: [
            {
              type: "text",
              content: "All content, trademarks, service marks, trade names, logos, and other intellectual property displayed on our website are the property of Sogdo or their respective owners. You may not use, reproduce, or distribute any content without prior written permission."
            }
          ]
        },
        {
          title: "6. Privacy Policy",
          paragraphs: [
            {
              type: "text",
              content: "Your privacy is important to us. Our Privacy Policy explains how we collect, use, and protect your information when you use our services. By using our services, you agree to the collection and use of information in accordance with our Privacy Policy."
            }
          ]
        },
        {
          title: "7. Limitation of Liability",
          paragraphs: [
            {
              type: "text",
              content: "In no event shall Sogdo or its suppliers be liable for any damages (including, without limitation, damages for loss of data or profit, or due to business interruption) arising out of the use or inability to use the materials on our website, even if Sogdo or an authorized representative has been notified orally or in writing of the possibility of such damage."
            }
          ]
        },
        {
          title: "8. Indemnification",
          paragraphs: [
            {
              type: "text",
              content: "You agree to indemnify and hold harmless Sogdo, its officers, directors, employees, and agents from any claims, damages, losses, or expenses (including reasonable attorneys' fees) arising from your use of our services or violation of these terms."
            }
          ]
        },
        {
          title: "9. Termination",
          paragraphs: [
            {
              type: "text",
              content: "We may terminate or suspend your access to our services immediately, without prior notice or liability, for any reason whatsoever, including without limitation if you breach the Terms."
            }
          ]
        },
        {
          title: "10. Governing Law",
          paragraphs: [
            {
              type: "text",
              content: "These Terms shall be interpreted and governed by the laws of the State of California, without regard to its conflict of law provisions. Our failure to enforce any right or provision of these Terms will not be considered a waiver of those rights."
            }
          ]
        },
        {
          title: "11. Changes to Terms",
          paragraphs: [
            {
              type: "text",
              content: "We reserve the right, at our sole discretion, to modify or replace these Terms at any time. If a revision is material, we will try to provide at least 30 days notice prior to any new terms taking effect."
            }
          ]
        },
        {
          title: "12. Contact Information",
          paragraphs: [
            {
              type: "text",
              content: "If you have any questions about these Terms of Service, please contact us:"
            }
          ],
          contactInfo: [
            { label: "Email", value: "legal@sogdo.com" },
            { label: "Phone", value: "+1 (555) 123-4567" },
            { label: "Address", value: "123 Tech Street, Innovation District, San Francisco, CA 94105" }
          ]
        }
      ]
    })

    return {
      introContent,
      contentData
    }
  }
}
</script>